import { createFileRoute } from '@tanstack/react-router'

import OrderDetailPage from '@/views/orders/pages/orders-detail.page'

export const Route = createFileRoute('/phong-nha/loyalty/$id')({
  component: OrderDetailPage,
})

